import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

function generateGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

function Main() {
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const handleRefreshChat = () => {
            const newUrl = `/chat?id=${generateGUID()}`;
            navigate(newUrl);
        }

        handleRefreshChat();
    }, [user]);

    return (<div />)
}

export default Main;